(function () {
  if (customElements.get('quantity-input')) return;

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.product__qty-input');
      if (!this.input) return;
      const minus = this.querySelector('[data-qty-minus]');
      const plus = this.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => this.step(-1));
      if (plus) plus.addEventListener('click', () => this.step(1));
    }

    step(dir) {
      const min = parseInt(this.input.min || '1', 10);
      let value = parseInt(this.input.value || '1', 10);
      if (isNaN(value)) value = min;
      value = Math.max(min, value + dir);
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('quantity-input', QuantityInput);
})();
